import { render, staticRenderFns } from "./TopRiskAdjustedReturn.vue?vue&type=template&id=0b4a9102&"
import script from "./TopRiskAdjustedReturn.vue?vue&type=script&lang=js&"
export * from "./TopRiskAdjustedReturn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports